import SwaggerParser from '@apidevtools/swagger-parser';

// This should reflect the structure of your OpenAPI JSON
export interface OpenAPIPathItem {
  get?: OpenAPIOperation;
  post?: OpenAPIOperation;
  put?: OpenAPIOperation;
  delete?: OpenAPIOperation;
  patch?: OpenAPIOperation;
  // Include other HTTP methods (put, delete, etc.) if needed
}

export interface OpenAPIOperation {
  summary?: string;
  description?: string;
  operationId?: string;
  requestBody?: OpenAPIRequestBody;
  parameters?: OpenAPIParameter[];
  responses?: OpenAPIResponses;
}

export interface OpenAPIRequestBody {
  content: { [mediaType: string]: OpenAPIContent };
}

// This is used for any top-level query or path params
// e.g. /checkout/shipment/{shipmentId}/confirm has the shipmentId as a parameter
// everything that is explicitly in the payload will instead be defined in the schema
export interface OpenAPIParameter {
  name: string;
  in: string;
  description?: string;
  required?: boolean; // previous definition of required
  schema?: OpenAPISchema;
}

export interface OpenAPISchema {
  type: string;
  title?: string;
  format?: string;
  items?: OpenAPISchema;
  properties?: Record<string, OpenAPISchema>;
  required?: string[]; // encore adds this to everything that does not have the 'optional' tag
  // Include other properties as needed
}

export interface OpenAPIResponses {
  // Include other status codes as needed
  '200'?: OpenAPIResponse;
  '201'?: OpenAPIResponse;
  '400'?: OpenAPIResponse;
  '404'?: OpenAPIResponse;
  '500'?: OpenAPIResponse;
  default?: OpenAPIResponse;
}

export interface OpenAPIResponse {
  description: string;
  content?: { [mediaType: string]: OpenAPIContent };
}

export interface OpenAPIContent {
  schema: OpenAPISchema;
}

export interface OpenAPI {
  paths: Record<string, OpenAPIPathItem>;
  components: OpenAPIComponents;
}

export interface OpenAPIComponents {
  schemas: Record<string, OpenAPISchema>;
}

async function getOpenApiJSON(): Promise<OpenAPI> {
  try {
    const response = await fetch('/openApiClient.json');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const openApiJSON = await response.json();

    // Dereference the API document
    const api = (await SwaggerParser.dereference(openApiJSON)) as OpenAPI;
    return api;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function getEndpointData(endpoint: string): Promise<OpenAPIPathItem> {
  const api: OpenAPI = await getOpenApiJSON();
  const endpointData: OpenAPIPathItem = api.paths[`/${endpoint}`];

  if (!endpointData) {
    throw new Error(`Endpoint ${endpoint} not found in API definition`);
  }

  return endpointData;
}

export async function getSchema(schemaName: string): Promise<OpenAPISchema> {
  const api: OpenAPI = await getOpenApiJSON();
  const schema: OpenAPISchema = api.components.schemas[schemaName];

  if (!schema) {
    throw new Error(`Schema ${schemaName} not found in API definition`);
  }

  return schema;
}

export async function getModelDefinition(modelName: string): Promise<OpenAPISchema> {
  const api: OpenAPI = await getOpenApiJSON();
  const modelDefinition: OpenAPISchema = api.components.schemas[modelName];

  if (!modelDefinition) {
    throw new Error(`Model ${modelName} not found in API definition`);
  }

  return modelDefinition;
}
